export const SET_HAMBURGER_MENU_STATE = 'SET_HAMBURGER_MENU_STATE';
export const SET_MAIN_MENU_LIST = 'SET_MAIN_MENU_LIST';